const CAMPAIGN_REFERRER_MAP = {
  MC_ORGANIC_organicsearch_google:
    /^(https?:\/\/)?(www\.)?(google\.|google\.com|googleusercontent\.)/i,
  MC_ORGANIC_organicsearch_yahoo: /^(https?:\/\/)?(www\.)?search\.yahoo\.com/i,
  MC_ORGANIC_organicsearch_bing: /bing\.com/i,
  MC_ORGANIC_organicsearch_baidu: /baidu\.com/i,
  MC_ORGANIC_organicsearch_duckduckgo: /duckduckgo\.com/i,
  MC_ORGANIC_organicsearch_yandex: /^(https?:\/\/)?(www\.)?yandex\./i,
  MC_ORGANIC_organicsearch_ecosia: /ecosia\.org/i,
  MC_ORGANIC_llmsearch_gemini: /^(https?:\/\/)?(www\.)?gemini\.google\.com/i,
  MC_ORGANIC_llmsearch_chatgpt: /chatgpt\.com/i,
  MC_ORGANIC_llmsearch_perplexity: /perplexity\.ai/i,
  MC_ORGANIC_llmsearch_claude: /claude\.ai/i,
  MC_ORGANIC_llmsearch_deepseek: /deepseek\.com/i,
  MC_ORGANIC_llmsearch_meta: /meta\.ai/i,
  MC_ORGANIC_llmsearch_copilot:
    /^(https?:\/\/)?(www\.)?(copilot\.microsoft\.com|m365\.cloud\.microsoft)/i,
  MC_ORGANIC_llmsearch_openai: /openai\.com/i,
  // TODO: Remove after testing
  MC_ORGANIC_test_qau: /^(https?:\/\/)?qau\.www\.london\.edu/i,
};

export const getCampaignName = (referrer: string) => {
  for (const [campaign, regex] of Object.entries(CAMPAIGN_REFERRER_MAP)) {
    if (regex.test(referrer)) {
      return campaign;
    }
  }
  return null;
};
